import {
  useGetPayoutQuote,
  useCreatePayout,
  GetPayoutQuoteBodyMethod,
  CreatePayoutBodyDestination,
  CreatePayoutBodyPurpose,
  CreatePayoutBodySourceOfFunds,
  useValidatePayout,
  ValidatePayoutBodyMethod,
  UnionPayAccount
} from '@utx/utx-access-client';
import { ACCESS_BASE_URL } from 'App';

export interface usePayoutQuoteParams {
  idempotencyKey: string;
  accountId: string;
  sourceCurrency: string;
  sourceAmount?: number;
  destinationCurrency: string;
  destinationAmount?: number;
  method: GetPayoutQuoteBodyMethod;
  destinationCountry: string;
}

export interface usePayoutSubmitParams {
  method: GetPayoutQuoteBodyMethod;
  destination: CreatePayoutBodyDestination;
  quoteId: string;
  purpose: CreatePayoutBodyPurpose;
  sourceOfFunds: CreatePayoutBodySourceOfFunds;
  accountId: string;
  remarks?: string;
  token?: string;
  verifyType?: number;
  sms_otp?: string;
}
export const usePayout = () => {
  const quoteQuery = useGetPayoutQuote({ axios: { baseURL: ACCESS_BASE_URL } });
  const runPayoutQuote = (params: usePayoutQuoteParams, onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
    const { idempotencyKey, accountId, sourceCurrency, sourceAmount, destinationCurrency, destinationAmount, method, destinationCountry } =
      params;
    quoteQuery.mutate(
      {
        data: {
          idempotencyKey: idempotencyKey,
          accountId: accountId,
          sourceAmount: sourceAmount && sourceAmount,
          sourceCurrency: sourceCurrency && sourceCurrency,
          destinationCurrency: destinationCurrency && destinationCurrency,
          destinationAmount: destinationAmount && destinationAmount,
          method: method,
          destinationCountry: destinationCountry
        }
      },
      {
        onSuccess,
        onError
      }
    );
  };

  const submitQuery = useCreatePayout({ axios: { baseURL: ACCESS_BASE_URL } });
  const runPayoutSubmit = (params: usePayoutSubmitParams, onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
    const { method, destination, quoteId, purpose, sourceOfFunds, accountId, remarks, token, verifyType, sms_otp } = params;
    submitQuery.mutate(
      {
        data: {
          method: method,
          destination: destination,
          quoteId: quoteId,
          purpose: purpose,
          sourceOfFunds: sourceOfFunds,
          accountId: accountId,
          remarks: remarks
          // token: token,
          // verifyType: verifyType,
          // sms_otp: sms_otp
        }
      },
      {
        onSuccess,
        onError
      }
    );
  };

  return { runPayoutQuote, runPayoutSubmit };
};

export interface useTransferPeerValidateParams {
  method: ValidatePayoutBodyMethod;
  destination: UnionPayAccount;
}

export const useTransferPeerValidatePayout = () => {
  const transferPeerValidatePayoutQuery = useValidatePayout({ axios: { baseURL: ACCESS_BASE_URL } });
  const runTransferPeerValidatePayout = (
    params: useTransferPeerValidateParams,
    onSuccess?: (data: any) => void,
    onError?: (error: any) => void
  ) => {
    const { method, destination } = params;
    transferPeerValidatePayoutQuery.mutate(
      {
        data: {
          method,
          destination
        }
      },
      {
        onSuccess,
        onError
      }
    );
  };

  return { runTransferPeerValidatePayout };
};
